const getType = (input) => input.getAttribute("type");
const getName = (input) => input.getAttribute("name");
const getFalseWeightValue = (input) => input.getAttribute("data-false-value");
const getTrueWeightValue = (input) => input.getAttribute("data-true-value");

const getValue = (input) => {
  let radioValue = 0;
  switch (getType(input)) {
    case "checkbox":
      if (input.checked) {
        return getTrueWeightValue(input);
      } else {
        return getFalseWeightValue(input);
      }
      break;
    case "radio":
      if (input.checked) {
        radioValue = input.value;
        return radioValue;
      }
      break;
    default:
      return input.value;
  }
};

export const getInputValues = (values, root) => {
  //get all input values in the quiz component root on current step
  const formElements = ["input", "select"];
  const inputs = root.querySelectorAll(formElements);
  inputs.forEach((input) => {
    console.log(getValue(input));
    if (getName(input)) {
      values[getName(input)] = parseInt(getValue(input));
    }
  });
  return values;
};

export const getTotal = (valuesTotal) => {
  const scoreSum = Object.values(valuesTotal).reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  return scoreSum;
};
